/**
 * Bridge session modes/types + Krybot agent IDs — keep in sync with
 * Krysalis_Backend/app/catalog/krysalis_bridge_catalog.json (identical bytes).
 */
import raw from './krysalis_bridge_catalog.json';

export const krysalisBridgeCatalogVersion = raw.catalog_version;

export const krysalisBridgeCatalog = raw;

/** Same order as JSON `bridge_session_modes` — use for strict typing. */
export const BRIDGE_SESSION_MODES = [
  'CAPTURE',
  'EXPAND',
  'IMPROVE',
  'DIAGNOSE',
] as const satisfies readonly (typeof raw.bridge_session_modes)[number][];

export type BridgeSessionMode = (typeof BRIDGE_SESSION_MODES)[number];

const cats = raw.bridge_session_type_categories;

/** Ordered: foundation → deep_dive → product_maturity */
export const BRIDGE_SESSION_TYPES = [
  ...cats.foundation,
  ...cats.deep_dive,
  ...cats.product_maturity,
] as const;

export type BridgeSessionType = (typeof BRIDGE_SESSION_TYPES)[number];

export type BridgeSessionTypeCategory = keyof typeof raw.bridge_session_type_categories;

export function isBridgeSessionMode(s: string): s is BridgeSessionMode {
  return (BRIDGE_SESSION_MODES as readonly string[]).includes(s);
}

export function isBridgeSessionType(s: string): s is BridgeSessionType {
  return (BRIDGE_SESSION_TYPES as readonly string[]).includes(s);
}

export type KrybotAgentRow = (typeof raw.krybot_agents)[number];

export type KrybotAgentId = KrybotAgentRow['id'];

const _agentIds = new Set(raw.krybot_agents.map((a) => a.id));

export function isKrybotAgentId(s: string): s is KrybotAgentId {
  return _agentIds.has(s as KrybotAgentId);
}

export function krybotSkillBundle(agentId: KrybotAgentId): string {
  const row = raw.krybot_agents.find((a) => a.id === agentId);
  if (!row) {
    throw new Error(`Unknown Krybot agent id: ${agentId}`);
  }
  return row.skill_bundle;
}
